/*
  Bliks · fiche produit
  - Bouton d'achat qui suit les étapes : tant que le fichier obligatoire manque,
    le bouton visible ouvre l'import Upload Kit. Une fois le fichier ajouté,
    c'est le vrai bouton « Ajouter au panier » de Dawn qui s'affiche.
  - Barre collante mobile : elle ne fait que cliquer sur ces mêmes boutons,
    donc elle ne contourne jamais l'upload ni les champs obligatoires.
  - Palier suivant : sélectionne la quantité proposée.
  - Événements dataLayer légers pour mesurer le parcours.
*/
(function () {
  function track(name, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, extra || {}));
    } catch (e) {}
  }

  function initRoot(root) {
    if (root.dataset.bkInit) return;
    root.dataset.bkInit = '1';

    var form = root.querySelector('product-form');
    var submit = form && form.querySelector('button[type="submit"][name="add"]');
    if (!submit) return;

    var buttons = submit.parentElement;
    var guide = document.createElement('button');
    guide.type = 'button';
    guide.className = 'button button--full-width button--primary bk-cta-guide';
    guide.hidden = true;
    guide.innerHTML = '<span>Importer mes visuels</span><svg width="20" height="20" viewBox="0 0 26 26" aria-hidden="true"><path d="M13 17V5M8 10l5-5 5 5M5 20h16" stroke="currentColor" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    buttons.insertBefore(guide, submit);

    var priceTag = document.createElement('span');
    priceTag.className = 'bk-cta-price';
    submit.appendChild(priceTag);

    function uploadField() {
      return root.querySelector('.uploadkit-upload-field');
    }
    function missingFile() {
      var f = uploadField();
      return !!(f && f.getAttribute('invalid') === 'true');
    }
    function currentPrice() {
      var p = root.querySelector('[id^="price-"] .price-item--last, [id^="price-"] .price-item--regular');
      return p ? p.textContent.trim() : '';
    }
    function openUpload() {
      var f = uploadField();
      if (!f) return;
      var b = f.querySelector('.uploadkit-button');
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (b) b.click();
    }

    guide.addEventListener('click', function () {
      track('bliks_cta_upload');
      openUpload();
    });

    function unitLine() {
      var priceEl = root.querySelector('[id^="price-"]');
      var q = root.querySelector('.bk-opt--quantite input:checked + label');
      if (!priceEl || !q) return;
      var line = root.querySelector('.bk-unitline');
      if (!line) {
        line = document.createElement('p');
        line.className = 'bk-unitline';
        priceEl.insertAdjacentElement('afterend', line);
      }
      var n = q.querySelector('.bk-q__n');
      var u = q.querySelector('.bk-q__u');
      var txt = (n ? n.firstChild.textContent.trim() : '') + (u ? ' · ' + u.textContent.trim() : '');
      if (line.textContent !== txt) line.textContent = txt;
    }

    var sticky = buildSticky(root, submit, guide);
    var wasMissing = null;

    function sync() {
      var missing = missingFile();
      guide.hidden = !missing || submit.disabled;
      submit.classList.toggle('bk-hidden', missing && !submit.disabled);
      var price = currentPrice();
      var tag = price || '';
      if (priceTag.textContent !== tag) priceTag.textContent = tag;
      if (sticky) sticky.update(missing, price);
      unitLine();
      if (wasMissing === true && missing === false) track('bliks_file_added');
      wasMissing = missing;
    }

    var obs = new MutationObserver(sync);
    obs.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['invalid', 'disabled'] });
    sync();

    root.addEventListener('click', function (e) {
      var up = e.target.closest('[data-bk-pick]');
      if (!up) return;
      var input = document.getElementById(up.getAttribute('data-bk-pick'));
      if (input) {
        track('bliks_palier_click', { palier: input.value });
        input.click();
      }
    });
  }

  function buildSticky(root, submit, guide) {
    var bar = document.createElement('div');
    bar.className = 'bk-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="bk-sticky__info"><span class="bk-sticky__sel"></span>' +
      '<span class="bk-sticky__row"><span class="bk-sticky__price"></span><span class="bk-sticky__msg"></span></span></div>' +
      '<button type="button" class="bk-sticky__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    var sel = bar.querySelector('.bk-sticky__sel');
    var price = bar.querySelector('.bk-sticky__price');
    var msg = bar.querySelector('.bk-sticky__msg');
    var btn = bar.querySelector('.bk-sticky__btn');
    var state = { missing: true };

    btn.addEventListener('click', function () {
      track('bliks_sticky_click', { missing_file: state.missing });
      // Toujours passer par les boutons de la fiche : mêmes contrôles, mêmes règles.
      if (state.missing) guide.click();
      else submit.click();
    });

    var cta = submit.parentElement;
    var visible = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var past = !en.isIntersecting && en.boundingClientRect.top < 0;
          var before = !en.isIntersecting && en.boundingClientRect.top > 0;
          visible = past || before;
          bar.classList.toggle('is-on', visible && window.innerWidth < 750);
        });
      }).observe(cta);
    }

    return {
      update: function (missing, p) {
        state.missing = missing;
        var vals = [].map.call(root.querySelectorAll('variant-selects input:checked'), function (i) {
          return i.value.replace(/⭐/g, '').trim();
        });
        sel.textContent = vals.join(' · ');
        price.textContent = p;
        msg.textContent = missing ? 'Il manque tes visuels' : 'Visuels ajoutés';
        msg.classList.toggle('is-ok', !missing);
        btn.disabled = submit.disabled;
        btn.innerHTML = missing
          ? '<svg width="17" height="17" viewBox="0 0 26 26" aria-hidden="true"><path d="M13 17V5M8 10l5-5 5 5M5 20h16" stroke="currentColor" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>Mes visuels'
          : 'Ajouter au panier';
      },
    };
  }

  function init() {
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(initRoot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
